module.exports = (__webpack_require__(16))(175);


//////////////////
// WEBPACK FOOTER
// delegated ./src/collections/ItemCollection.js from dll-reference girder_lib
// module id = 57
// module chunks = 0